module.exports = __webpack_public_path__ + "static/media/DIRAD.319630f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/DIRAD.svg
// module id = 480
// module chunks = 0